import React, { useContext, useEffect } from "react";
import "./BundleBooking.css";
import { StateContext } from "../../../../StateProvider";
import NeedHelp from "../../../../Utilities/components/NeedHelp";
import Footer from "../../../../Footer";
import { BackButton } from "../../../../Utilities/components/Buttons";
import { useNavigate } from "react-router-dom";

function BundleBooking() {
  const navigate = useNavigate();
  const { loggedIn, bookingData, setBookingData } = useContext(StateContext);
  const today = new Date();

  /* --------------------------------------------------
     🚫 Redirect if NOT logged in
  -------------------------------------------------- */
  useEffect(function () {
    if (loggedIn === false) {
      navigate("/login");
    }
  }, [loggedIn, navigate]);

  /* --------------------------------------------------
     Initialize bookingData
  -------------------------------------------------- */
  useEffect(function () {
    setBookingData(function (prev) {
      var updated = Object.assign({}, prev);
      updated.bookingType = "store/bundle";

      if (!updated.bookingInfo) {
        updated.bookingInfo = {
          selectedPackage: "",
          dateRange: [today, today],
        };
      }
      return updated;
    });
  }, []);

  /* --------------------------------------------------
     Handle Package Selection
  -------------------------------------------------- */
  function handlePackageSelect(key) {
    setBookingData(function (prev) {
      var updated = Object.assign({}, prev);
      var current = updated.bookingInfo || {};
      var isSame = current.selectedPackage === key;

      updated.bookingInfo = Object.assign({}, current, {
        selectedPackage: isSame ? "" : key,
      });

      return updated;
    });
  }

  var selected = "";
  if (
    bookingData &&
    bookingData.bookingInfo &&
    bookingData.bookingInfo.selectedPackage
  ) {
    selected = bookingData.bookingInfo.selectedPackage;
  }

  var bundles = [
    {
      key: "10-Pack",
      label: "10-Day Bundle",
      color: "#4CA7DF",
      price: 510,
      days: 10,
      savings: "7%",
      perDay: (510 / 10).toFixed(2),
      expiration: "90 Days",
      bestFor: "Casual daycare users",
    },
    {
      key: "20-Pack",
      label: "20-Day Bundle",
      color: "#FFB516",
      price: 960,
      days: 20,
      savings: "13%",
      perDay: (960 / 20).toFixed(2),
      expiration: "90 Days",
      bestFor: "Frequent daycare guests",
    },
  ];

  return (
    <div>
      <div className="bundle-back-button-container">
        <BackButton />
      </div>

      <div className="bundle-container">
        <div className="bundle-header">
          <h2>Daycare Bundles</h2>
          <p>Buy more days, enjoy more savings and flexibility.</p>
        </div>

        <div className="bundle-chart">
          {bundles.map(function (bundle) {
            var isSelected = selected === bundle.key;

            return (
              <div
                key={bundle.key}
                className={"bundle-card " + (isSelected ? "selected" : "")}
                style={{
                  borderColor: bundle.color,
                  "--selected-color": bundle.color,
                }}
                onClick={function () {
                  handlePackageSelect(bundle.key);
                }}
              >
                <h3 style={{ color: isSelected ? "white" : bundle.color }}>
                  {bundle.label}
                </h3>
                <p className="bundle-price">${bundle.price}</p>

                <div className="bundle-info">
                  <div>
                    <span className="info-label">Days Included:</span>
                    <span className="info-value">{bundle.days}</span>
                  </div>
                  <div>
                    <span className="info-label">Savings:</span>
                    <span className="info-value">{bundle.savings}</span>
                  </div>
                  <div>
                    <span className="info-label">Per-Day Rate:</span>
                    <span className="info-value">${bundle.perDay}</span>
                  </div>
                  <div>
                    <span className="info-label">Expiration:</span>
                    <span className="info-value">{bundle.expiration}</span>
                  </div>
                </div>

                <div className="bundle-footer">
                  <p className="bundle-tip">{bundle.bestFor}</p>
                  <button
                    className={
                      "bundle-select-btn " + (isSelected ? "active" : "")
                    }
                  >
                    {isSelected ? "Selected ✓" : "Select"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="sign-up-section">
        <NeedHelp />
      </div>

      <Footer />
    </div>
  );
}

export default BundleBooking;
